import React from 'react'
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";


const CategoryHeader = (props) => {
    const { title } = props
    return (
        <div className="header-sec">
            <p className="insurence-title">
                {title} <KeyboardArrowDownIcon />
            </p>
        </div>
    )
}

export default CategoryHeader